import IndustryAccount from "views/IndustryAccount";
import Configuration from "views/configuration/Configuration"
import EuGeneralPurposeStatistics from "views/EuGeneralPurposeStatistics"
import Artifacts from "views/industry/Artifacts";
import JobAdvertisements from "views/industry/JobAdvertisements";
import DemandAnalytics from "views/demand/analytics/DemandAnalytics"
import DemandForecasting from "views/demand/forecasting/DemandForecasting"
import SupplyAnalytics from "views/supply/analytics/SupplyAnalytics"
import SupplyForecasting from "views/supply/forecasting/SupplyForecasting"
import GapCompetition from "views/industry/GapCompetition";
import FutureNeeds from "views/industry/FutureNeeds";
import InsightsFuture from "views/industry/InsightsFuture";
import EmployeeSkills from "views/industry/EmployeeSkills";
import OrganizationInformation from "views/industry/OrganizationInformation";
import { ProjectorAnalytics } from "views/supply/projector/ProjectorAnalytics";

var routes = [
  {
    path: "/account",
    name: "My Organization",
    icon: "nc-icon nc-single-02",
    component: <IndustryAccount />,
    layout: "/industry",
  },
  {
    path: "/account/gap-competition",
    name: "Gap With Competition",
    icon: "nc-icon nc-single-02",
    component: <GapCompetition />,
    layout: "/industry",
  },
  {
    path: "/account/future-needs",
    name: "Future Needs",
    icon: "nc-icon nc-single-02",
    component: <FutureNeeds />,
    layout: "/industry",
  },
  {
    path: "/account/insights-future",
    name: "Insights on Future",
    icon: "nc-icon nc-single-02",
    component: <InsightsFuture />,
    layout: "/industry",
  },
  {
    path: "/account/advertisements",
    name: "My Advertisements",
    icon: "nc-icon nc-single-02",
    component: <JobAdvertisements />,
    layout: "/industry",
  },
  {
    path: "/account/artifacts",
    name: "My Artifacts",
    icon: "nc-icon nc-single-02",
    component: <Artifacts />,
    layout: "/industry",
  },
  {
    path: "/account/employee-skills",
    name: "Employee KU",
    icon: "nc-icon nc-single-02",
    component: <EmployeeSkills />,
    layout: "/industry",
  },
  {
    path: "/account/organization-info",
    name: "Organization Information",
    icon: "nc-icon nc-single-02",
    component: <OrganizationInformation />,
    layout: "/industry",
  },
  {
    name: "Demand",
    isCategory: true, 
    children: [
      {
        path: "/demand-analytics",
        name: "Analytics",
        icon: "nc-icon nc-zoom-split",
        component: <DemandAnalytics />,
        layout: "/industry",
      },
      {
        path: "/demand-forecasting",
        name: "Forecasting",
        icon: "nc-icon nc-chart-pie-36",
        component: <DemandForecasting />,
        layout: "/industry",
      },
      {
        path: "/projector-analytics",
        name: "Projector",
        icon: "nc-icon nc-map-big",
        component: <ProjectorAnalytics />,
        layout: "/industry",
      },
    ],
  },
  {
    name: "Supply",
    isCategory: true,
    children: [
      {
        path: "/supply-analytics",
        name: "Analytics",
        icon: "nc-icon nc-zoom-split",
        component: <SupplyAnalytics />,
        layout: "/industry",
      },
      {
        path: "/supply-forecasting",
        name: "Forecasting",
        icon: "nc-icon nc-chart-pie-36",
        component: <SupplyForecasting />,
        layout: "/industry",
      },
    ],
  },
  {
    path: "/configuration",
    name: "Configuration",
    icon: "nc-icon nc-settings",
    component: <Configuration />,
    layout: "/industry",
  },
];
export default routes;
